const API_ENDPOINT = 'https://5dfyxsgsre.execute-api.us-east-1.amazonaws.com/dev/sendemail';
const RECIPIENT_EMAIL = 'rob@wencelworldwide.com';

export const DEFAULT_RECIPIENT_EMAIL = RECIPIENT_EMAIL;

export async function sendInquiry({ formType, formData, recipientEmail = RECIPIENT_EMAIL }) {
  const payload = {
    formType,
    formData,
    recipientEmail
  };

  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}
